import { PositionListTargetContact } from "./customer-position-list.class";

export class PositionListTarget {
  constructor(
    public positionListTargetId: string,
    public contact: PositionListTargetContact) {

  }
}